<template>
  <loader-wrapper :loading="isLoadingDay">
    <section id="bid-day-map">
      <el-row :gutter="24" type="flex" align="middle">
        <day-date-map :day="day" />
      </el-row>
      <el-row :gutter="24" type="flex" align="middle">
        <el-col :span="24" style="margin-bottom: 8px">
          <p class="route_tble__dayInfo mr-p" style="margin: inherit">
            Надо: <b>{{ day.cars_count }}</b>
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="24" type="flex" align="middle">
        <day-count-map :day="day" />
      </el-row>
      <el-row :gutter="24" type="flex" align="middle">
        <el-col :span="24" class="flex-col" style="margin-bottom: 8px">
          <p class="route_tble__dayInfo mr-p" style="margin: inherit">
            Недобор:
          </p>
          <img src="@/assets/img/black_truck.svg" alt="" />
          {{ getShortage(day) }}
        </el-col>
      </el-row>
      <el-row :gutter="24" type="flex" align="middle">
        <day-prices-map :day="day" />
      </el-row>
      <el-row :gutter="24" type="flex" align="middle">
        <day-buttons
          :bid-id="bidId"
          :day="day"
          @close="onClose"
          v-on="$listeners"
        />
      </el-row>
    </section>
  </loader-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import DayButtons from './components/DayButtons'
import DayCountMap from './components/DayCountMap'
import DayDateMap from './components/DayDateMap'
import DayPricesMap from './components/DayPricesMap'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'BidDayMap',
  components: {
    LoaderWrapper,
    DayDateMap,
    DayPricesMap,
    DayCountMap,
    DayButtons,
  },
  props: {
    bidId: {
      type: Number,
      default: 0,
    },
    day: {
      type: Object,
      default: () => {},
    },
    docInfo: {
      type: Object,
      default: () => {},
    },
    docLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoadingDay() {
      return this.getLoading('Day')
    },
  },
  methods: {
    onClose() {
      this.$emit('close-day', this.day)
    },
    getShortage(b) {
      if (!b.responses_count_total) {
        return b.cars_count
      }
      const res = b.cars_count - b.responses_count_total

      return res > 0 ? res : 0
    },
  },
}
</script>

<style lang="sass">
#bid-day-map
  position: relative
  border-radius: 2px
  padding: 20px
  background: #F4F4F4
  border: 1px solid #CBCBCB
  box-sizing: border-box
  font-size: 16px
  margin: 15px 0
  color: #000
  .mr-p
    margin-right: 5px!important
  .flex-col
    display: flex
    align-items: center
    img
      margin-right: 10px
  .sh-checkbox
    .el-checkbox__label
      display: none
  .rt-dayInfo
    margin:  0
    line-height: 0
    color: #aaa8ab
    font-weight: normal
    font-size: 12px
    justify-content: normal
  .rt_price
    display: flex
    font-size: 16px
    line-height: 21px
    color: #98A9BC
    font-weight: normal
  .more_info
    font-weight: normal
    color: #409EFF
    &:hover
      cursor: pointer
      text-decoration: underline
</style>
